module.exports = __webpack_public_path__ + "img/dccd4771aac26737cbd56a29d1be42d3.svg";